// @ts-check
// Lo común del movimiento del rediseño (Fase 6): si hay que moverse, el ritmo
// del estilo y la salida de una fila. Sin CSS propio: lo importan los momentos
// de los editores (`momentos.js`) y el panel del profesor sin traerse nada más.

/** @param {string} propiedad */
function token(propiedad) {
  const raiz = globalThis.document?.documentElement;
  if (!raiz) return '';
  return globalThis.getComputedStyle(raiz).getPropertyValue(propiedad).trim();
}

/**
 * ¿Hay que moverse? No con movimiento reducido, ni en clásico y plano, que no
 * ganan animaciones nuevas (`--movimiento: 0`, `tokens.css`).
 * @returns {boolean}
 */
export function hayMovimiento() {
  if (globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return false;
  return token('--movimiento') === '1';
}

/** El carácter del estilo (`--movimiento-ritmo`): la curva de sus gestos. */
export function ritmoDelEstilo() {
  return token('--movimiento-ritmo');
}

/** Lo que tarda una fila en salir (plan de la Fase 3, §4.8). */
const SALIDA = 200;

/**
 * Una fila que se va (Fase 6c: «al aprobar, la fila sale en 200 ms»): se
 * desvanece hacia un lado y la promesa se cumple al acabar. Sin movimiento,
 * o sin fila, se cumple al momento. Nunca falla: si la animación se corta,
 * se sigue igual.
 * @param {Element | null | undefined} fila
 * @returns {Promise<void>}
 */
export function desvanecerFila(fila) {
  if (!(fila instanceof globalThis.HTMLElement) || !hayMovimiento()) return Promise.resolve();
  if (typeof fila.animate !== 'function') return Promise.resolve();
  const animacion = fila.animate([{ opacity: 1 }, { opacity: 0, translate: '1.5rem 0' }], {
    id: 'momento-salir',
    duration: SALIDA,
    easing: 'ease-in',
    fill: 'forwards',
  });
  return animacion.finished.then(
    () => undefined,
    () => undefined,
  );
}
